import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { WebFamGallery } from '../models/gallery.model';

/**
 * Pliki drzewa - adresy obrazków i galeria profilu.
 * Endpointy siedzą pod /file, dlatego osobny serwis, a nie PersonService.
 */
@Injectable()
export class FileService {

    constructor(private httpClient: HttpClient) { }

    /** Zdjęcia osoby (person_files) oraz pliki jej źródeł i cytowań. */
    getPersonGallery(personId: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return this.httpClient.get<WebFamGallery>(
            environment.backendUrl + '/file/gallery/tree/' + tree + '/person/' + personId
        );
    }

    /**
     * Oznaczenie osoby na zdjęciu. Prostokąt (ułamki 0..1) jest opcjonalny -
     * bez niego zapisujemy samo "ta osoba jest na zdjęciu", przez co zdjęcie
     * pojawia się też w jej galerii.
     */
    savePhotoTag(fileId: string, personId: string,
                 region?: { x: number; y: number; w: number; h: number } | null, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        const data = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            person_id: personId,
            x: region ? region.x : null,
            y: region ? region.y : null,
            w: region ? region.w : null,
            h: region ? region.h : null
        };
        return this.httpClient.post<{ status: string }>(
            environment.backendUrl + '/file/tag/tree/' + tree + '/file/' + fileId, { data }
        );
    }

    /**
     * Opis zdjęcia. Idzie za plikiem, więc to samo zdjęcie w galerii kilku
     * osób ma wszędzie ten sam podpis.
     */
    savePhotoTitle(fileId: string, title: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return this.httpClient.patch<{ status: string; title: string }>(
            environment.backendUrl + '/file/title/tree/' + tree + '/file/' + fileId, { data: { title } }
        );
    }

    /**
     * Zdjęcie oznaczenia. Zdjęcie zostaje w galerii osoby - odpina się je
     * osobno, z potwierdzeniem.
     */
    removePhotoTag(fileId: string, personId: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return this.httpClient.delete<{ status: string }>(
            environment.backendUrl + '/file/tag/tree/' + tree + '/file/' + fileId + '/person/' + personId
        );
    }

    /** Pełny obraz. */
    imageUrl(fileId: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return environment.backendUrl + '/file/download/image/tree/' + tree + '/file/' + fileId;
    }

    /** Miniatura (300 px, zawsze PNG). */
    thumbnailUrl(fileId: string, treeId?: string) {
        const tree = treeId ?? environment.currentTree;
        return environment.backendUrl + '/file/download/thumbnail/tree/' + tree + '/file/' + fileId;
    }
}
